/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    DEFAULT_HEIGHT: 400,
    DEFAULT_WIDTH: 0,
    DEFAULT_AUTORESIZE_LAG: 100
};
